<template>
    <div
        v-if="hasMessages || hasRefs"
        class="mb-0"
        v-bind:class="{ 'alert alert-danger': useErrorStyle }">
        <div v-if="hasMessages">
            {{ displayedMessagesTitle }}
            <ul class="no-bullets mb-0">
                <li
                    v-for="msg in messages"
                    v-bind:key="msg">
                    {{ msg }}
                </li>
            </ul>
        </div>
        <div
            v-if="hasRefs"
            class="mb-0"
            v-bind:class="{ 'mt-3': hasMessages }">
            {{ displayedRefsTitle }}
            <ul class="no-bullets mb-0">
                <li
                    v-for="info in refInfo"
                    v-bind:key="info.source"
                    data-test-role="reference-type-item">
                    {{ info.source }}:
                    <ul class="no-bullets mb-0">
                        <li
                            v-for="ref in info.refs.filter((r, i, refs) => refs.indexOf(r) === i)"
                            v-bind:key="ref"
                            data-test-role="reference-name-item">
                            {{ ref }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
    <div
        v-else
        class="mb-0"
        v-bind:class="{ 'alert alert-info': useErrorStyle }">
        {{ displayedOkTitle }}
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/referencesError.i18n";

    export default {
        props: {
            /**
             * referencesErrorModel expects an object that implements
             * IReferencesErrorModel
             */
            referencesErrorModel: { type: Object, required: true },
            useErrorStyle: { type: Boolean, required: false, default: true },
            messagesTitle: { type: String, required: false, default: null },
            refsTitle: { type: String, required: false, default: null },
            okTitle: { type: String, required: false, default: null }
        },
        computed: {
            displayedMessagesTitle() {
                return this.messagesTitle || this.defaultMessagesTitle;
            },
            displayedRefsTitle() {
                return this.refsTitle || this.defaultRefsTitle;
            },
            displayedOkTitle() {
                return this.okTitle || this.defaultOkTitle;
            },
            messages() {
                return this.referencesErrorModel.BlockingMessages || [];
            },
            references() {
                return this.referencesErrorModel.BlockingReferences || {};
            },
            refInfo() {
                const refs = [];
                const keys = Object.keys(this.references);
                keys.forEach(
                    function (k) {
                        refs.push({
                            source: k,
                            refs: this.references[k]
                        });
                    }.bind(this)
                );
                return refs;
            },
            hasMessages() {
                return this.messages.length > 0;
            },
            hasRefs() {
                return this.refInfo.length > 0;
            },
            ...mapI18n(KEYS, NAMESPACE)
        }
    };
</script>
